import $ from 'jquery';
import './Libraries/LFM/Menu';

$('.navigation__list--level1').menu({desktop: 1340});
